import {Component, OnInit, OnDestroy} from '@angular/core';
import {RestApiService} from '../rest-api.service';
import {MessageService} from '../message.service';
import {Router} from '@angular/router';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {NotifierService} from 'angular-notifier';
import {Subscription} from 'rxjs';

@Component({
  selector: 'app-temp-ssc-report',
  templateUrl: './temp-ssc-report.component.html',
  styleUrls: ['./temp-ssc-report.component.css']
})
export class TempSscReportComponent implements OnInit, OnDestroy{
    private notifier: NotifierService;
    fromDate: any;
    toDate: any;
    respObject: any;
    private clientId: number;
    userName: string;
    private userAuth: Subscription;
    private ticketTypeSubscription: Subscription;
    ticketTypeId: number;
    userGroups: any;
    userGroupId: number;
    groupName: string;
    private storage: any;
    types = [];
    reportFileName: string;
    reportLink: string;
    reportFiles = [];
    reportUrl: string;
    reportLoaded: boolean;
    reportType: number;

    constructor(private _rest: RestApiService, private messageService: MessageService,
                private route: Router, private modalService: NgbModal, notifier: NotifierService) {
        this.notifier = notifier;
    }

    ngOnInit() {
        this.reportType = 2;     // 1=SSC report, 2=Temp SSC report
        this.reportLoaded = true;
        this.fromDate = '';
        this.toDate = '';
        this.reportUrl = this.messageService.REPORT_PATH;
        if (this.messageService.clientId) {
            this.clientId = this.messageService.clientId;
            this.userGroups = this.messageService.groupId;
            this.userName = this.messageService.loginName;
            if (this.messageService.getSupportGroup() === null) {
                this.userGroupId = this.userGroups[0].groupId;
                this.groupName = this.userGroups[0].grpName;
            } else {
                const group = this.messageService.getSupportGroup();
                this.userGroupId = group.groupId;
                this.groupName = group.grpName;
            }
            this.onPageLoad();
        } else {
            this.userAuth = this.messageService.getClientUserAuth().subscribe(auth => {
                this.clientId = auth[0].clientId;
                this.userGroups = auth[0].groupId;
                this.userName = auth[0].login_name;
                if (this.messageService.getSupportGroup() === null) {
                    this.userGroupId = this.userGroups[0].groupId;
                    this.groupName = this.userGroups[0].grpName;
                } else {
                    const group = this.messageService.getSupportGroup();
                    this.userGroupId = group.groupId;
                    this.groupName = group.grpName;
                }
                this.onPageLoad();
            });
        }
    }

    onPageLoad() {
        this.ticketTypeSubscription = this._rest.getTicketTypeForTicketCreation_LNT(this.clientId, this.userGroupId).subscribe((res1) => {
            this.respObject = res1;
            if (this.respObject.success) {
                this.storage = JSON.parse(localStorage.getItem('dd'));
                this.types = this.respObject.details;
                if (this.storage === null) {
                    this.ticketTypeId = this.types[0].id;
                } else {
                    const type = this.storage.type;
                    for (let i = 0; i < this.types.length; i++) {
                        if (this.types[i].id === type) {
                            this.ticketTypeId = this.types[i].id;
                            break;
                        }
                    }
                }
            }
        });
        this.getReportList();
    }

    getReportList() {
        this.reportLoaded = false;
        this._rest.getSscReportList(this.clientId, this.reportType).subscribe((res) => {
            this.respObject = res;
            if (this.respObject.success) {
                this.reportLoaded = true;
                for (let i = 0; i < this.respObject.details.length; i++) {
                    this.respObject.details[i].createdate =
                        this.messageService.datePipeFunc(this.respObject.details[i].createdate);
                }
                this.reportFiles = this.respObject.details;
            } else {
                this.notifier.notify('error', this.respObject.errorMessage);
            }
        }, (err) => {
            // console.log('err==', err);
            this.notifier.notify('error', this.messageService.SERVER_ERROR);
        });
    }

    generate() {
        let date1 = new Date(this.fromDate).valueOf();
        let date2 = new Date(this.toDate).valueOf();
        let diffTime = Math.abs(date2 - date1);
        let diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24)); 

        if (this.fromDate !== '' && this.toDate !== '' && this.fromDate !== null && this.toDate !== null) {
            if(Number(diffDays)  <= 31){

            const fromDate = this.messageService.ticketConverter(this.fromDate, 1);
            const toDate = this.messageService.ticketConverter(this.toDate, 1);
            this._rest.getTempSscReport(fromDate, toDate, this.clientId, this.ticketTypeId).subscribe((res) => {
                this.respObject = res;
                this.fromDate = '';
                this.toDate = '';
                this.notifier.notify('success', this.messageService.REPORT_SUCCESS);
            });
        }else{
            this.notifier.notify('error', this.messageService.REPORT_TIME);
    
        }
    
        } else {
            this.notifier.notify('error', this.messageService.BLANK_ERROR_MESSAGE);
        }
    }

    changeRouting() {
        if (this.messageService.dashboardUrl !== undefined && this.messageService.dashboardUrl !== null) {
            this.messageService.changeRouting(this.messageService.dashboardUrl);
        }
    }

    download() {
    }

    ngOnDestroy() {
        if (this.userAuth) {
            this.userAuth.unsubscribe();
        }

        if (this.ticketTypeSubscription) {
            this.ticketTypeSubscription.unsubscribe();
        }
    }
    downloadFile(attachedFilePath: any) {
        this._rest.downloadFile(this.clientId, attachedFilePath, 'report').subscribe((res: any) => {
            if (res.success) {
                window.location.href = res.value;
            } else {
                alert(res.errorMessage);
            }
        }, (err) => {
        });
    }
}
